import type { DashboardUserRoleFilter, DashboardUserStatusFilter } from "../../types/users"
import { listDashboardRoles, listDashboardUsers } from "./users-server"

export const DASHBOARD_USERS_QUERY_KEY = "dashboard-users"
export const DASHBOARD_ROLES_QUERY_KEY = "dashboard-roles"
export const DASHBOARD_USERS_STALE_MS = 30 * 1000
export const DASHBOARD_ROLES_STALE_MS = 60 * 1000

/**
 * What the users table asks for before anyone has filtered it.
 *
 * The view holds these in atoms, which is fine for the view and useless to a
 * route loader — a loader cannot read component state, so a prefetch has to
 * describe the same request some other way. These are the atoms' initial
 * values, named once here so the two cannot drift into prefetching a page the
 * table will not then ask for.
 */
export const DASHBOARD_USERS_LIST_DEFAULTS = {
  page: 1,
  pageSize: 20,
  roleFilter: "all" as DashboardUserRoleFilter,
  search: "",
  statusFilter: "active" as DashboardUserStatusFilter,
}

export function dashboardUsersQueryKey({
  page,
  pageSize,
  roleFilter,
  search,
  statusFilter,
}: typeof DASHBOARD_USERS_LIST_DEFAULTS) {
  return [DASHBOARD_USERS_QUERY_KEY, page, pageSize, search.trim(), statusFilter, roleFilter] as const
}

export function dashboardUsersQueryOptions(
  input: typeof DASHBOARD_USERS_LIST_DEFAULTS = DASHBOARD_USERS_LIST_DEFAULTS
) {
  return {
    queryFn: () =>
      listDashboardUsers({
        data: {
          page: input.page,
          pageSize: input.pageSize,
          roleFilter: input.roleFilter,
          search: input.search.trim() || undefined,
          statusFilter: input.statusFilter,
        },
      }),
    queryKey: dashboardUsersQueryKey(input),
    staleTime: DASHBOARD_USERS_STALE_MS,
  }
}

export function dashboardRolesQueryOptions() {
  return {
    queryFn: () => listDashboardRoles({ data: {} }),
    queryKey: [DASHBOARD_ROLES_QUERY_KEY] as const,
    staleTime: DASHBOARD_ROLES_STALE_MS,
  }
}
